/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Error_Report_BugInputs */

const en_ui_error_report_bug = /** @type {(inputs: Ui_Error_Report_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report bug`)
};

const de_ui_error_report_bug = /** @type {(inputs: Ui_Error_Report_BugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler melden`)
};

/**
* | output |
* | --- |
* | "Report bug" |
*
* @param {Ui_Error_Report_BugInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_error_report_bug = /** @type {((inputs?: Ui_Error_Report_BugInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Error_Report_BugInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_error_report_bug(inputs)
	return de_ui_error_report_bug(inputs)
});